/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SaleResponse } from '../../models/sale-response';

export interface MembersSalesGet$Params {}

export function membersSalesGet(
  http: HttpClient,
  rootUrl: string,
  params?: MembersSalesGet$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SaleResponse>> {
  const rb = new RequestBuilder(rootUrl, membersSalesGet.PATH, 'get');
  if (params) {
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SaleResponse>;
      }),
    );
}

membersSalesGet.PATH = '/members/sales';
